import React, { useEffect } from 'react';
import { withRouter, useHistory } from 'react-router'
import { useDispatch } from 'react-redux';
import { makeStyles, Grid, Typography, IconButton, Paper } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import * as actionTypes from '../../../store/actions/actionTypes';


const useStyles = makeStyles((theme) => ({
    content: {
        display: 'flex',
        width:'100%',
        justifyContent:'center',
        padding: '32px',
        margin: '32px',
    },

}));

const ErrorFallBack = ({ error }) =>  {

    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();

    // Reset the cached redux slices once on mount — in an effect, not during render. Dispatching
    // during render is a React anti-pattern. Placed before the isChunkError early-return to satisfy
    // rules-of-hooks (hooks must run unconditionally before any return).
    useEffect(() => {
        dispatch({ type: actionTypes.RESET_TABLECACHE });
        dispatch({ type: actionTypes.RESET_INVOICE });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isChunkError = error && (
        error.name === 'ChunkLoadError' ||
        error.message?.includes('Loading chunk')
    );

    if (isChunkError) {
        const lastReload = Number(sessionStorage.getItem('chunk_reload_at') || 0);
        // cap stale chunk reloads at 2 per 10 minute window, then fall through to the error UI
        const attempts = Date.now() - lastReload > 600000
            ? 0
            : Number(sessionStorage.getItem('chunk_reload_count') || 0);
        if (attempts < 2) {
            sessionStorage.setItem('chunk_reload_at', String(Date.now()));
            sessionStorage.setItem('chunk_reload_count', String(attempts + 1));
            window.location.reload();
            return null;
        }
    }

    return (
        <Grid className={classes.content}>
            <Paper style={{padding: '32px', margin: '32px'}}>
                <Grid container justifyContent='center' style={{marginBottom: '10px'}}>
                    <Typography variant='h4'>Something went wrong.</Typography>
                </Grid>

                <Grid container justifyContent='center' style={{marginBottom: '10px'}}>
                    <Typography>Try refreshing the page.</Typography>
                </Grid>

                <Grid container justifyContent='center'>
                    <IconButton
                        style={{backgroundColor: '#ffc107', color: 'black'}}
                        onClick={(e) => { history.go(0) }}
                    >
                        <RefreshIcon/>
                    </IconButton>
                </Grid>
            </Paper>
        </Grid>
    )
}

export default withRouter(ErrorFallBack);
